/** @jsx jsx */
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import { Modal } from 'antd-mobile'
import { Button, ButtonWrap } from '@styles/button.style'
import { ModalBg } from '@styles/base.style'
import useRootStore from '@store/useRootStore'
import React, { Fragment, useEffect, useState } from 'react'
import { CartItem } from '@store/matchupStore'
import { CharacterToolTip } from '@styles/match.style'
// img
import ToolTipCharacter from '@assets/images/icon/matchup_icon/tool-tip-character.png'
import WarningImg from '@assets/images/icon/etc_icon/warning.png'
import { SameMatchWrap } from './index.style'
import { MatchMaketSlot } from './Slot'

export interface MatchMarketSlotProps {
  key: string,
  sportId: number,
  homeTeamName: string,
  awayTeamName: string,
  marketName: string,
  outcomeName: string,
  rate: number,
}

function addMatchMarketSlot(cartItem: CartItem): MatchMarketSlotProps {
  const item: MatchMarketSlotProps = {
    key: cartItem.marketType,
    sportId: cartItem.sportId,
    homeTeamName: cartItem.match.homeTeamName,
    awayTeamName: cartItem.match.awayTeamName,
    marketName: cartItem.marketName,
    outcomeName: cartItem.selectedOutcome.name,
    rate: cartItem.rate,
  }

  return item
}

const SameMatchPopup: React.FC = () => {
  const { globalStore, matchupStore } = useRootStore()
  const { visibleSameMatchPopup } = globalStore
  const [matchMarketSlots, setMatchMarketSlots] = useState([])
  const matchMarketItems: MatchMarketSlotProps[] = []

  useEffect(() => {
    const carts = matchupStore.getSameMatchCartList()
    carts.forEach((cartItem) => {
      const item = addMatchMarketSlot(cartItem)
      matchMarketItems.push(item)
    })

    setMatchMarketSlots(matchMarketItems)
  }, [visibleSameMatchPopup])

  const onCloseModal = () => {
    globalStore.setVisibleSameMatchPopup(false)
  }

  const onClickYes = () => {
    const carts = matchupStore.getSameMatchCartList()
    carts.forEach((item) => {
      matchupStore.removeCartItem(item.tournamentId, item.matchId, item.value, false, false)
    })

    matchupStore.addSelectedCartItem()
    onCloseModal()
  }

  const onClickNo = () => {
    onCloseModal()
  }

  const viewSlotKey = 'matchMarketSlot'

  const MatchGroup = (
    <div className="same-match-group">
      <ul>
        {matchMarketSlots.map((listItem, index) => (
          <li key={`${viewSlotKey}_${listItem.key}`} className="same-match-list">
            <MatchMaketSlot {...listItem}/>
          </li>
        ))}
      </ul>
    </div>
  )

  const title = (
    <Fragment>
      <img src={WarningImg} alt="경고" className="modal-warning-ico"/>
      동일경기 내 조합불가
    </Fragment>
  )

  return (
    <Modal
      transparent
      visible={visibleSameMatchPopup}
      maskClosable={false}
      onClose={onCloseModal}
      className="custom-dialog filter-popup"
      title={title}
    >
      <SameMatchWrap>

        {MatchGroup}
      </SameMatchWrap>
      <CharacterToolTip className="same-match-modal show">
        <img src={ToolTipCharacter} alt="툴팁 캐릭터" className="tooltip-img"/>
        <div className="tooltip-box">
          <p className="tooltip-box--txt">
            동일경기 내에서 메인과 추가Bet을
            <br/>
            조합하여 선택할 수 없습니다.
          </p>
          <p className="tooltip-box--txt bottom">
            위 선택된 폴드를 취소하시겠습니까?
          </p>
        </div>
      </CharacterToolTip>

      <ButtonWrap className="middle-modal-btn-wrap">
        <Button onClick={onClickNo} className="two-btn cancel dialog">
          아니요
        </Button>
        <Button secondary onClick={onClickYes} className="two-btn dialog">
          예
        </Button>
      </ButtonWrap>

      <ModalBg onClick={onCloseModal}/>
    </Modal>
  )
}

export default observer(SameMatchPopup)
